import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Label from './Label';

const Toggle = ({ name, options, label, onChange, title, value, disabled, required }) => (
  <div className={classnames('ncss-form-group', { required: required })}>
    {label ? (
      <Label title={title} htmlFor={title} className='mt2-sm d-sm-b'>
        {label}
      </Label>
    ) : null}
    <div className='ncss-radio-contianer flex-container row space-between border body-4'>
      {options &&
        options.length &&
        options.map(option => (
          <button
            key={option.value}
            className='p1-sm border-right u-full-height'
            type='button'
            onClick={() => onChange(option.value)}
            disabled={disabled}
          >
            <div style={{ padding: '0 20px' }}>
              <input
                className='ncss-radio'
                type='radio'
                name={name}
                id={`${name}-${option.value}`}
                onChange={() => onChange(option)}
                checked={option.value === value.value ? 'checked' : false}
                disabled={disabled}
              />
              <label htmlFor={`${name}-${option.value}`}>{option.label}</label>
            </div>
          </button>
        ))}
    </div>
  </div>
);

Toggle.defaultProps = {
  options: [],
  disabled: false,
  required: false,
  value: null,
  title: null
};

Toggle.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array,
  label: PropTypes.any.isRequired,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string,
  value: PropTypes.string
};

export default Toggle;
